<template>
  <div id="vl">
    <img class="logo" src="@/assets/logo.svg" alt="Verenigingsloterij" />
    <div class="powered-by">
      <span>Powered by</span>
      <div>
        <img src="@/assets/lotify.svg" alt="Lotify" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Verenigingsloterij"
};
</script>

<style lang="scss">
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

#vl {
  margin: 0;
  padding: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img.logo {
    vertical-align: bottom;
    width: 600px;
    max-width: 70vw;
    margin-bottom: 100px;
  }

  .powered-by {
    display: flex;
    flex-direction: column;
    text-align: left;
    width: 600px;
    max-width: 70vw;

    span {
      font-size: 12px;
      text-transform: uppercase;
      font-weight: 500;
      opacity: 0.6;
      margin-bottom: 6px;
    }

    img {
      width: 140px;
      margin-right: 80px;
      margin-bottom: 40px;
    }
  }
}
</style>
